export enum ApplicantStatusEnum {
  SUBMITTED = 1, // подано
  CONFIRMED_OR_CONFIRMED_WITH_DOCUMENTS = 20, // Принято / Принято и подтверждено оригиналами документов
  CONFIRMED_WITHOUT_DOCUMENTS = 3, // принято, не подтверждено оригиналами документов
  CONFIRMED_WITH_DOCUMENTS = 4, // принято и подтверждено оригиналами документов
  RECOVERED = 2, // восстановлено
  REJECTED = 7, // отказано в приёме  = заявления, по которым абитуриентам отказано в приеме в вуз; отклонены;
  ARCHIVED = 8, // документы возвращены
  SENT_TO_REVISION = 5, // отправлено на доработку
  CORRECTED = 6, // доработано
  SAVED_NOT_SUBMITTED = 0, // отменено абитуриентом
  /* FOR PEM */
  RECEIVED_ON_PEM = 9, // Принят на базе РЕМ
  TRANSFERED_TO_COLLEGE = 10 // Переведен на базу колледжа
}



// WEBPACK FOOTER //
// ./src/app/common/enums/applicant-status.enum.ts